module.exports = __webpack_public_path__ + "img/10_1.c7a0b1ea.jpg";